<template>
    <div class="top_con">
       <el-form :inline="true" :model="formInline" class="demo-form-inline" label-width="100px">
           <el-row :gutter="8" >
                <el-col :span="6">
                    <el-form-item label="设备产权编号"> 
                        <el-input v-model="formInline.propertynum"  placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备归属人">
                        <el-input v-model="formInline.belonger" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="设备型号">
                        <el-input v-model="formInline.modelc" placeholder="请输入" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="出厂年份">
                         <el-date-picker  v-model="formInline.cctime" type="month" placeholder="选择月" value-format="yyyy-MM"> </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row :gutter="8">
                <el-col :span="6">
                    <el-form-item label="生产厂家"> 
                        <el-input v-model="formInline.manufacturer"  placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="租赁状态"> 
                        <el-select v-model="formInline.lease" placeholder="请选择" style="margin-right:20px;">
                            <el-option label="未租赁" value="2"></el-option>
                            <el-option label="已租赁" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <div style="float:right;">
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="info" @click="clearS">重置</el-button>
                    </el-form-item>
                </div>
            </el-row>
        </el-form>
        <el-button type="primary" @click="look(0)" style="margin-top:20px;">添加设备</el-button>
        <el-table  ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange" max-height="580px">
            <el-table-column  prop="equipmentnum"  label="设备编号"></el-table-column>
            <el-table-column  prop="propertynum"  label="产权编号" show-overflow-tooltip></el-table-column>
            <el-table-column prop="modelc"  label="设备型号"></el-table-column>
            <el-table-column prop="cctime"  label="设备出厂时间" ></el-table-column>
            <el-table-column prop="belonger"  label="设备归属人" ></el-table-column>
            <el-table-column prop="zcost"  label="租赁状态" >
                <template slot-scope="scope">
                    <span v-if="scope.row.lease==1">已租赁</span>
                    <span v-else>未租赁</span>
                </template>
            </el-table-column>
            <el-table-column prop="tian"  label="运行天数" ></el-table-column>
            <el-table-column prop="manufacturer"  label="生产厂家" show-overflow-tooltip></el-table-column>
            <el-table-column prop="address"  label="操作">
                <template slot-scope="scope" v-if="user.roleId!=3">
                    <el-link :underline="false" @click="look(2,scope.row.id)" style="margin-right:20px;" size="small">修改</el-link>
                    <el-link :underline="false" @click="del(scope.row.id)" style="margin-right:20px;" size="small">删除</el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination  background layout="prev, pager, next"  :pager-count="5" :page-size="value" :total='total' @current-change="handleCurrentChange"></el-pagination>
        <div>
            <el-dialog :title="zp_tit" :visible.sync="dialogFormVisible" width="64%">
                <el-form :model="form"  label-width="100px">
                    <el-row :gutter="8">
                        <el-col :span="8">
                            <el-form-item label="设备编号"> 
                                <el-input v-model="form.equipmentnum"  placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="产权编号">
                                <el-input v-model="form.propertynum" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="设备类型">
                                <el-input v-model="form.modelc" placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="8">
                         <el-col :span="8">
                            <el-form-item label="设备出厂时间">
                                <el-date-picker style="width:100%;" v-model="form.cctime" type="date" placeholder="选择时间" class="timessss" value-format="yyyy-MM-dd"> </el-date-picker>
                            </el-form-item>
                        </el-col>
                       <el-col :span="8">
                            <el-form-item label="设备归属人"> 
                                <el-input v-model="form.belonger"   placeholder="请输入" ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="生产厂家">
                                <el-input v-model="form.manufacturer"  placeholder="请输入"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;" v-if="tit_type!=1">
                    <el-button type="primary" @click="subAdd" v-if="tit_type==0">保存</el-button>
                    <el-button type="primary" @click="subEdit" v-if="tit_type==2">确认修改</el-button>
                    <el-button @click="dialogFormVisible = false">取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import {QueryPricing,newList,openXq,EditList,sbDel} from '@/utils/api'
export default {
    data(){
        return{
            houseLis:[],
            formInline: {
                propertynum:'',
                belonger:'',
                modelc:'',
                cctime:'',
                manufacturer:'',
                lease:'',
            },
            roleid:'',
            dialogFormVisible:false,
            chuKu:false,
            zp_tit:"添加设备",
            tit_type:0,
            form:{
                
            },
            formLabelWidth: '120px',
            value:10,
            total:10,
            multipleSelection:[],
            tableData: [],
            fileList: [],
            ckid:'',
            cknum:'',
            pageNum:1,
            user:{}
        }
    },
    methods:{
        tableRowClassName({row}){
            if(row.red==1){
                return 'warning-row';
            }
        },
        handleCurrentChange(val){
            this.pageNum=val;
            let param ={
                numPerPage:this.value,
                pageNum:val,
                formInline:this.formInline
            }
            QueryPricing(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list
            });
        },
        onSubmit(){
            let param ={
                numPerPage:this.value,
                pageNum:1,
                formInline:this.formInline
            }
            QueryPricing(param).then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        clearS(){
            this.formInline={}
            QueryPricing().then(res=>{
                this.total=res.total;
                this.tableData=res.list;
            });
        },
        look(idx,id){
            this.dialogFormVisible=true
            if(idx==0){
                this.zp_tit="添加设备";
                this.tit_type=0;
                 this.form={}
            }else if(idx==1){
                this.zp_tit="查看详情";
                this.tit_type=1;
                openXq({id:id}).then(res=>{
                   this.form=res;
                })
            }else if(idx==2){
                this.zp_tit="编辑";
                this.tit_type=2;
                openXq({id:id}).then(res=>{
                   this.form=res;
                   this.fileList=this.form.img
                })
            }
            
        },
        handleSelectionChange(val){
            this.multipleSelection = val;
        },
        upload_cg(file,fileList){
            this.fileList.push({name:file.name,url:file.file_url})
		},
        war(id){
            this.chuKu=true
            this.ckid=id
        },
        subAdd(){
            let param ={
                userId:this.user.uid,
                formInline:this.form
            }
            newList(param).then(res=>{
                this.dialogFormVisible=false;
                QueryPricing().then(res=>{
                    this.total=res.total;
                    this.tableData=res.list;
                });
            })
        },
        subEdit(){
            let param ={
                userId:this.user.uid,
                formInline:this.form
            }
            EditList(param).then(res=>{
                this.dialogFormVisible=false;
                QueryPricing().then(res=>{
                    this.total=res.total;
                    this.tableData=res.list;
                });
            })
        },
        del(id){
            this.$confirm('确定删除该条, 是否继续?', '删除', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
                }).then(() => {
                    sbDel({userId:this.user.uid,id:id}).then(res=>{
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        QueryPricing().then(res=>{
                            this.total=res.total;
                            this.tableData=res.list
                        });
                    });
                }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        }
    },
    mounted(){
        this.user=JSON.parse(localStorage.getItem('userInfo'))
        QueryPricing().then(res=>{
            this.total=res.total;
            this.tableData=res.list;
        });
    }
}

</script>
<style scoped>
    .top_con{
        width:100%;
        height:auto;
        padding:20px;
        box-sizing:border-box;
    }
    .warning-row{
        background: red;
    }
    .el-form-item{
        vertical-align:middle;
        margin-right:20px;
    }
    .el-input{
        /* width:193px; */
        margin-right:10px;
    }
    .el-pagination {
        text-align: right;
        margin-top: 20px;
    }
    .edit_width .el-upload-list{
        width:260px;
    }
    .el-image{
        margin-right:30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Stock.vue